/*eslint-disable*/
import md5 from './md5.js';
import getCookie from './getCookieValue.js';
var spm = getCookie('spm'),
    utm_source = getCookie('utm_source');

function getSign(data, type) {
    console.log('objec');
    let keys = Object.keys(data).sort(),
        str = ''
    keys.map(key => {
        if (key != 'sign') {
            str += '&' + key + '=' + data[key]
        }
    })
    str = str.substring(1);
    if (type === 'v2') {
        return md5(str + '7jr73hs50s8g7l1m');
    }
    return md5(str + '2k834u09wsdu899l');
}

function buildRequestParam(data, type = 'v1') {
    let requestData = {
        ...data
    };
    requestData.app = 'luna'; //调用方应用名['', 'ttmp']
    requestData.timestamp = new Date().getTime(); //调用时间
    requestData.utm_source = utm_source; //流量来源
    requestData.spm = spm; //流量来源,非外投页面传‘-’，外投页面情况待定
    requestData.sign = getSign(requestData, type); //验证签名
    return requestData;
}
export default buildRequestParam;